<template>
  <div>
    <div class="modal-card" v-show="!isLoading">
      <header class="modal-card-head">
        <p class="modal-card-title">Detalii sofer</p>
      </header>
      <section class="modal-card-body">
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Nume</label>
          </div>
          <div class="field-body">
            <div class="field">
              <p class="control is-expanded">
                <input
                  class="input"
                  type="text"
                  placeholder="Ion Popescu"
                  v-model="driver.name"
                  autofocus
                >
              </p>
              <p
                class="help is-danger"
                v-if="$v.driver.name.$dirty && !$v.driver.name.required"
              >Camp obligatoriu.</p>
            </div>
          </div>
        </div>



        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">CI/BI/Pass</label>
          </div>
          <div class="field-body">
            <div class="field">
              <p class="control">
                <b-datepicker
                  placeholder="Data expirare CI/BI/PASS"
                  v-model="driver.ci"
                  :date-formatter="dateFormatter"
                  editable
                  icon="calendar-today"
                ></b-datepicker>
              </p>
            </div>
          </div>
        </div>

        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Permis auto</label>
          </div>
          <div class="field-body">
            <div class="field">
              <p class="control">
                <b-datepicker
                  placeholder="Data expirare Permis auto"
                  v-model="driver.permit"
                  :date-formatter="dateFormatter"
                  icon="calendar-today"
                  editable
                ></b-datepicker>
              </p>
            </div>
          </div>
        </div>

        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Categorii permis</label>
          </div>
          <div class="field-body">
            <div class="field">
              <p class="control is-expanded">
                <input
                  class="input"
                  type="text"
                  placeholder="Categoriile permisului: B, A1, BE, etc."
                  v-model="driver.permitCategories"                  
                >
              </p>                   
            </div>
          </div>
        </div>

        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Email</label>
          </div>
          <div class="field-body">
            <div class="field">
              <p class="control is-expanded">
                <input
                  class="input"
                  type="email"
                  placeholder="Ion.Popescu@parcauto.ro"
                  v-model="driver.email"
                  autofocus
                >
              </p>     
              <p
                class="help is-danger"
                v-if="$v.driver.email.$dirty && !$v.driver.email.email"
              >Email invalid (nume@parcauto.ro).</p>         
            </div>
          </div>
        </div>

        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Observatii</label>
          </div>
          <div class="field-body">
            <div class="field">
              <p class="control">
                <textarea
                  class="textarea"
                  placeholder="informatii suplimentare care vor fi atasate la email-ul trimis"
                  v-model="driver.comments"
                ></textarea>
              </p>
            </div>
          </div>
        </div>
        <p class="help is-info has-text-centered">Iti vom trimite un email cu 30 zile inainte de data de expirare a documentului.</p>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="$parent.close()">Renunta</button>
        <button class="button is-primary" :class="{'is-loading':isSaving}" @click.prevent="submit">
          <span class="icon is-small">
            <i class="fa fa-save"></i>
          </span>
          <span>Salveaza</span>
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { required, email } from "vuelidate/lib/validators";
import LoadingInfo from "@/components/LoadingInfo";

import { EventBus } from "@/event-bus.js";

export default {
  name: "DriverForm",
  props:['driverId','reload'],
  components: { LoadingInfo },
  computed: {
    ...mapGetters(["isLoading"])
  },
  data: function() {
    return {
      isSaving: false,
      driver: {
        id: null,
        name: "",
        ci: null,
        permit: null,
        email:"",
        comments: ""
      }
    };
  },
  validations: {
    driver: {
      name: { required },
      email: { email }
    }
  },
  methods: {
    ...mapActions([
      "saveDriver",
      "loadDrivers",
      "loadDriver"
    ]),
    dateFormatter(dt) {
      return dt.toLocaleDateString("ro-RO");
    },
    submit() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.isSaving = !this.isSaving;
        this.saveDriver(this.driver)
          .then(resp => {
            if (this.reload)
              this.reload();
            this.$parent.close();
            this.isSaving = !this.isSaving;
            EventBus.$emit("reload-data");
          })
          .catch(err => {
            this.isSaving = !this.isSaving;
            console.error(err);
          });
      }
    },
    load(id) {
      this.loadDriver(id)
        .then(resp => {
          if (resp.data.ci) resp.data.ci = new Date(resp.data.ci);
          if (resp.data.permit) resp.data.permit = new Date(resp.data.permit);
          this.driver = resp.data;
        })
        .catch(err => console.log("error loading driver:", err));
    }
  },
  mounted() {
          var vid = this.driverId;
          if (vid > 0) {
            this.load(vid);
          }
  }
};
</script>

